import { handleError } from '../common-message/message-action';
import { API_URL } from '../../../utils/config';
import { makeApiCall } from '../common/common-action';
import { TOGGLE_HELPCENTER_NOTIFICATION_STATE } from '../../action-contants';

export function getNotificationCount() {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: API_URL + '/notifications/count',
        withCredentials: true
      });
    } catch (error) {
      //for session expiry case
      dispatch(handleError(error));
    }
  };
}

export function getNotificationContent(limit, page) {
  const params = { limit, page };
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: API_URL + '/notifications',
        withCredentials: true,
        params: params
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function markNotification(mark_id, mark_all, status) {
  return async (dispatch) => {
    try {
      let params = {};
      if (mark_all) {
        params = { mark_all };
      } else {
        params = { mark_id };
      }
      params.status = status;
      return await makeApiCall({
        method: 'post',
        url: API_URL + '/notifications',
        withCredentials: true,
        params: params
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function toggleHelpcenterNotification(data) {
  return {
    type: TOGGLE_HELPCENTER_NOTIFICATION_STATE,
    data
  };
}
